import { render, staticRenderFns } from "./ListMyResources.vue?vue&type=template&id=3b444334&scoped=true"
import script from "./ListMyResources.vue?vue&type=script&lang=js"
export * from "./ListMyResources.vue?vue&type=script&lang=js"
import style0 from "./ListMyResources.vue?vue&type=style&index=0&id=3b444334&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b444334",
  null
  
)

export default component.exports